import React from "react";
import Info from "./Info";
import PhoneNumber from "./PhoneNumber";


export default function ZaloPhoneLink({value}) {


return( <Info
                title="Primary Phone"
                body={
                  <a
                    href={
                      "https://zalo.me/" + value.replace("0", "84")
                    }
                    target={"_blank"}
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                    className="neat"
                  >
                    <PhoneNumber value={value} />
                  </a>
                }
              />)
}